<template>
    <b-card-body>
        <p v-if="secciones.length === 0"><i>No hay secciones capturadas</i></p>
        <b-list-group v-else>
            <draggable :list="secciones" @update="moverSeccion">
              <b-list-group-item v-for="(element, index) in secciones"
                  :key="index"
                  :to="'/transparencia/normatividad/seccion/'+element._id">
                  {{element.nombre}}
              </b-list-group-item>
            </draggable>
        </b-list-group>

        <div v-if="puedeAgregarSeccion">
          <br>
            <b-row align-h="between">
              <b-col cols="2">
                <b-button v-if="secciones.length > 0"
                    size="sm"
                    variant="secondary"
                    v-b-tooltip.hover title="Descargar archivos de las secciones"
                    @click="descargarSecciones()">
                    <i class="fa fa-download fa-lg"></i>&nbsp;
                    <i class="fa fa-folder-open fa-lg"></i>
                </b-button>
              </b-col>
              <b-col cols="2" class="text-right">
                <b-button 
                    size="sm"
                    variant="primary"
                    @click="agregarSeccion()">
                    Agregar sección
                </b-button>
              </b-col>
            </b-row>
            
        </div>
    </b-card-body>
</template>

<script>
import swal from 'sweetalert'
import axios from 'axios'
import { mapGetters } from "vuex";

import draggable from 'vuedraggable'

export default {
  name: 'ItemSecciones',
  props: ["seccionesUp","tipoItem","nombre"],
  components:{
    draggable
  },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    puedeAgregarSeccion(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 112) >= 0 )
        return true;
      else
        return false;
    },
    editor() {
        return this.$refs.myTextEditor.quill
      },
  },
  watch: {
      seccionesUp(){
          this.secciones = this.seccionesUp;
      },
      '$route'(to, from) {
        this.id = to.params.id;
      }
  },
  data: function () {
    return {
        titulo: this.$route.name,
        id: this.$route.params.id,
        secciones:[]
    }
  },
  methods: {
    agregarSeccion(){
      swal({
        text: 'Ingrese nombre:',
        content: {
          element: "input",
          attributes: {
          placeholder: "Ingrese...",
          type: "text",
          }
        },
        closeOnClickOutside: true,
        button: {
          text: "Confirmar",
          closeModal: false,
        },
      })
      .then(nombre => {
        if (!nombre){
          swal.close();
        }else{
          this.$emit('enviandoStart');
          let ruta = '';
          if( this.tipoItem === 'menu')
            ruta = 'menu/'+this.id+'/seccion'
          else
            ruta = 'seccion/'+this.id;
          axios.post(this.httpURL+'/transparencia/normatividad/'+ruta,
                {nombre},
                {headers: {token:this.sessionToken}})
            .then(res => {
                swal.stopLoading();
                swal.close();
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                          text: res.data.mensaje });
                this.secciones.push(res.data.seccion);
                this.$emit('enviandoStop');
            })
            .catch(error => {
                this.$emit('enviandoStop');
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
        }
      });
    },
    moverSeccion(){
      let secIds = [];
      this.secciones.forEach(element => {
        secIds.push(element._id);
      });

      secIds = secIds.toString();
      //console.log(secIds);

      this.$emit('enviandoStart');
      axios.put(this.httpURL+'/transparencia/normatividad/'+this.tipoItem+'/'+this.id+'/moverSecs',
              {secs:secIds},
              {headers: {token:this.sessionToken}})
          .then(res => {
              //this.docs.splice(index,1);
              this.$emit('enviandoStop');
              this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                  text: 'Cambios guardados correctamente' });
          })
          .catch(error => {
              //console.log(error.response);
              this.$emit('enviandoStop');
              this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                  text: 'No se pudieron guardar los cambios' });
          });
    },
    descargarSecciones(){
      this.$emit('enviandoStart');
      axios({
              url: this.httpURL+'/transparencia/normatividad/seccion/'+this.id+'/download/secciones',
              method: 'POST',
              responseType: 'blob', // important
              data: {},
              headers:{token:this.sessionToken}
            })
          .then(res => {
              //this.docs.splice(index,1);
              let blob = new Blob([res.data], { type: 'application/zip' })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = this.nombre+'.zip'
              link.click()
              this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                  text: 'Documentos generados correctamente' });
              this.$emit('enviandoStop');
          })
          .catch(error => {
              //console.log(error.response);
              this.$emit('enviandoStop');
              this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                  text: 'No se pudieron ggenerar los documentos' });
          });
    },
    regresar(){
        this.$router.go(-1);
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>